/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Icons from "@fortawesome/free-solid-svg-icons";
import {
  faUserCheck,
  faEnvelope,
  faListCheck,
  faClock,
  faCreditCard,
  faMoneyBill,
  faTshirt,
 
} from "@fortawesome/free-solid-svg-icons";
import { Badge } from "primereact/badge";
import "./resources.scss";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useDispatch, useSelector } from "react-redux";
import {
  inboxEmail,
  selectInboxEmail,
} from "../../myMessages/inbox/inboxEmailSlice";
import jwt_decode from "jwt-decode";
import { empProfileDetails } from "../Profile/ProfileSlice";
import { MYLOUIETASKS } from "../../../../utils/CONSTANTS";
import DialogBox from "./DialogBox";
import {
  getNonLouielogic,
  NonLouielogic,
} from "../../louie/NonLouielogic/NonLouielogicSlice";
import { getResourceLink, getResourceLinks } from "./getResourceLinkSlice";
import {
  checkComplianceDashboardAccess,
  indiaComplianceDashboardDetails,
} from "../../IndiaComplianceDashboard/getIndiaComplianceDashboardSlice";
import { ScrollPanel } from "primereact/scrollpanel";
import { FedExDetails, getlistFedExDetails } from "./getFedExDetails";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { isTokenExpired } from "../../../../utils/msal-utils";
import AuthContext from "../../shared-components/authContext";
import Spinner from "../../../../utils/spinner";

const Resources = (ResourcesProps: any) => {
  const { inboxData } = useSelector(selectInboxEmail);
  const [messages, setMessages] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [oracleId, setOracleId] = useState("0");
  const dispatch = useDispatch();
  const { hasAccess: complianceAccess } =
    useSelector(indiaComplianceDashboardDetails) || {};
  const { profileData } = useSelector(empProfileDetails);
  const FedExDetailsData = useSelector(getlistFedExDetails);
  const listFedExDetails = useSelector(getlistFedExDetails);
  const { NonLouielogicflag } = useSelector(getNonLouielogic);
  // const [isSSOLogin, setIsSSOLogin] = useState(false);
  const { nonSSOlogout } = useContext(AuthContext);
  const [agentSchedulingVisible, setAgentSchedulingVisible] = useState(true);
  const workArrangementType =
    profileData?.automation?.employee?.work_arrangement_type;
  const POD = profileData?.POD;
  const { getResourceLinkData, getResourceLinkState } =
    useSelector(getResourceLinks) || {};

  const getIcon = (iconName: string) => {
    return (Icons as { [key: string]: any })[iconName] || Icons["faLink"];
  };
  
  const footerContent = (
    <div>
      <Button label="OK" onClick={() => setVisible(false)} autoFocus />
    </div>
  );
  const [visible, setVisible] = useState(false);
  const [pluxeeCard, setPluxeeCard] = useState(false);
  const [EquipmentTracker, setEquipmentTracker] = useState(false);
  const [DressCode, setDresscode] = useState(false);
  const footerContentPC = (
    <div>
      <Button label="OK" onClick={() => setPluxeeCard(false)} autoFocus />
    </div>
  );
  const footerContentDC = (
    <div>
      <Button label="OK" onClick={() => setDresscode(false)} autoFocus />
    </div>
  );
  const footerContentET = (
    <div>
      <Button
        label="Close"
        onClick={() => setEquipmentTracker(false)}
        autoFocus
      />
    </div>
  );

  // TTECONNECT-2768: fail-closed. Link must stay hidden until the gating effect
  // proves eligibility (allowlist, or internal transfer on/after TTF start date).
  const [mySchedulePopUpVisible, setMySchedulePopUpVisible] = useState(false);
  const [isSSOLogin, setIsSSOLogin] = useState(false);
  useEffect(() => {
    const SSOToken = localStorage.getItem("AccessToken");
    const nonSSOToken = localStorage.getItem("AccessToken-NonSSO");
    let id: any;
    if (nonSSOToken && isTokenExpired(nonSSOToken)) {
      nonSSOlogout();
    }
    if (SSOToken) {
      id = localStorage.getItem("oracleId");
      setIsSSOLogin(true);
    }
    if (nonSSOToken) {
      const decodedToken: any = jwt_decode(nonSSOToken);
      id = decodedToken?.oracleID;
    }
    setOracleId(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem("oracleId"), localStorage.getItem("email")]);

  useEffect(() => {
    if (oracleId !== null && oracleId !== undefined && oracleId !== "0") {
      const data = {
        input: {
          // request: {
          action: "Email",
          emailType: "EmailInbox",
          userOracleId: oracleId,
          // },
        },
      };
      dispatch<any>(inboxEmail(data));
    }
  }, [dispatch, oracleId]);
  let countryName = profileData?.automation?.employee?.location_country;
  let jobFamily = profileData?.automation?.employee?.job_family;
  useEffect(() => {
    if (
      oracleId !== null &&
      oracleId !== undefined &&
      oracleId !== "0" &&
      countryName !== null &&
      countryName !== undefined &&
      countryName !== "" &&
      jobFamily !== null &&
      jobFamily !== undefined &&
      jobFamily !== ""
    ) {
      const data = {
        // request: {
        action: "NonLouielogic",
        oracleId: oracleId,
        country: countryName,
        processName: countryName + " Onboarding",
        jobFamily: jobFamily,
        // },
      };
      dispatch<any>(NonLouielogic(data));
    }
  }, [dispatch, oracleId, countryName, jobFamily]);

  useEffect(() => {
    if (oracleId !== null && oracleId !== undefined && oracleId !== "0") {
      const data = {
        // request: {
        action: "getFedExDetails",
        oracleId: oracleId,
        // },
      };
      dispatch<any>(FedExDetails(data));
    }
  }, [dispatch, oracleId]);

  // India Compliance Dashboard — allowlist access check (shows link only to permitted users)
  useEffect(() => {
    if (oracleId && oracleId !== "0") {
      dispatch<any>(
        checkComplianceDashboardAccess({
          oracleId,
          email: localStorage.getItem("email") || "",
        })
      );
    }
  }, [dispatch, oracleId]);
  useEffect(() => {
    setMessages(inboxData);
  }, [inboxData]);

  useEffect(() => {
    if (
      oracleId !== null &&
      oracleId !== undefined &&
      oracleId !== "0" &&
      countryName !== null &&
      countryName !== undefined &&
      countryName !== "" &&
      jobFamily !== null &&
      jobFamily !== undefined &&
      jobFamily !== ""
    ) {
      const data = {
        action: "getResourceLinks",
        oracleId: oracleId,
        country: countryName,
        flag: "resourceLinks",
        jobFamily: jobFamily,
        is_sso: isSSOLogin,
      };
      dispatch<any>(getResourceLink(data));
    }
  }, [dispatch, oracleId, countryName, jobFamily, isSSOLogin]);

  const getLink = (rowData: any) => {
    return (
      <a
        href={`https://www.fedex.com/fedextrack/?trknbr=${rowData.TrackingNumber}`}
        target={"_blank"}
        rel="noreferrer"
      >
        {rowData.TrackingNumber}
      </a>
    );
  };
  useEffect(() => {
    const unreadMessages = messages.filter(
      (item: any) =>
        item.emailMain.status === "unread" &&
        item.emailMain?.emailDetails[0]?.sender_oracle_id !== oracleId
    );
    const unreadMessagesCount = unreadMessages.length;
    setUnreadCount(unreadMessagesCount);
  }, [messages, oracleId]);

  function handleClickAgentSchedule() {
    setAgentSchedulingVisible(true);
    ResourcesProps?.sendDataToParent(agentSchedulingVisible);
  }

  useEffect(() => {
    const reqId = ResourcesProps?.classRosterAndRequestId?.ClassRequestId;
    const rosterId = ResourcesProps?.classRosterAndRequestId?.ClassRosterId;
    // Treat empty-string / null / undefined as "not in roster" (e.g. removed from roster, empty ASTT).
    const hasRosterMatch =
      (reqId !== null && reqId !== undefined && reqId !== "") ||
      (rosterId !== null && rosterId !== undefined && rosterId !== "");
    if (hasRosterMatch) {
      const inAllowlist =
        rosterId === "14685" || rosterId === "14686" || rosterId === "15555" || rosterId === "15556" || rosterId === "18700" || rosterId === "18822" || rosterId === "15557" || rosterId === "15940" || rosterId === "20126" || rosterId === "20132" || rosterId === "20161" || rosterId === "20217" || rosterId === "20218" || rosterId === "20851" || rosterId === "20850" || rosterId === "20852";
      // My Schedule is visible ONLY for rosters in the allowlist
      if (inAllowlist) {
        setMySchedulePopUpVisible(true);
      } else {
        setMySchedulePopUpVisible(false);
      }
    } else {
      // No roster match (e.g. removed from roster / empty ASTT) -> always hide.
      setMySchedulePopUpVisible(false);
    }
  }, [
    ResourcesProps?.classRosterAndRequestId?.ClassRequestId,
    ResourcesProps?.classRosterAndRequestId?.ClassRosterId,
  ]);
  // Check API state before rendering
  if (getResourceLinkState === "pending") {
    <Spinner />;
  }
  return (
    <div className="card h-100 shadow-lg heightAuto">
      <div className="card-body mt-3">
        <ul className="list-unstyled customListStyle ms-3 myResourcesSectionLinks">
          {workArrangementType === "Work At Home" && POD === "TRUE" && (
            <li className="mb-3 fw-bold text-break-all pe-3">
              <FontAwesomeIcon
                icon={faEnvelope}
                className="me-3"
                style={{ fontSize: "1rem" }}
              />
              {unreadCount !== 0 ? (
                <a href="/messages">
                  <span style={{ color: "rgb(255, 153, 51)" }}>
                    My Messages
                  </span>{" "}
                  <Badge
                    value={unreadCount}
                    className="mr-2"
                    severity="warning"
                  />
                </a>
              ) : (
                <a href="/messages">My Messages</a>
              )}
            </li>
          )}

          <li className="mb-3 fw-bold text-break-all pe-3">
            <FontAwesomeIcon
              icon={faUserCheck}
              className="me-3"
              style={{ fontSize: "1rem" }}
            />
            <a href="/profile">My Profile</a>
          </li>

          {complianceAccess && (
            <li className="mb-3 fw-bold text-break-all pe-3">
              <FontAwesomeIcon
                icon={faListCheck}
                className="me-3"
                style={{ color: "rgb(255, 153, 51)", fontSize: "1rem" }}
              />
              <a href="/compliance-dashboard" style={{ color: "orange" }}>
                India Compliance Dashboard
              </a>
            </li>
          )}

          {mySchedulePopUpVisible && (
            <li className="mb-3 fw-bold text-break-all pe-3">
              <FontAwesomeIcon
                icon={faClock}
                className="me-3"
                style={{ fontSize: "1rem" }}
              />
              <a
                onClick={handleClickAgentSchedule}
                style={{ color: "var(--bs-link-color)", cursor: "pointer" }}
              >
                My Schedule
              </a>
            </li>
          )}

          {NonLouielogicflag === "false" && (
            <li className="mb-3 fw-bold text-break-all pe-3">
              <FontAwesomeIcon
                icon={faListCheck}
                className="me-3"
                style={{ color: "rgb(255, 153, 51)", fontSize: "1rem" }}
              />
              <a href={MYLOUIETASKS} style={{ color: "orange" }}>
                My Louie Tasks
              </a>
            </li>
          )}
          {/* Dynamic Resources from Database */}
          {getResourceLinkData && Array.isArray(getResourceLinkData) ? (
            getResourceLinkData.map((resource: any, index: number) => {
              const icon = getIcon(resource.icon);
              return (
                <li key={index} className="mb-3 fw-bold text-break-all">
                  <FontAwesomeIcon
                    icon={icon}
                    className="me-3"
                    style={{ fontSize: resource.style || "1rem" }}
                  />
                  <a href={resource.url} target="_blank" rel="noreferrer">
                    {resource.subfeature || "Resource Link"}
                  </a>
                </li>
              );
            })
          ) : getResourceLinkData ? (
            <li className="mb-3 fw-bold text-break-all">
              <FontAwesomeIcon
                icon={getIcon(getResourceLinkData.icon)}
                className="me-3"
                style={{ fontSize: getResourceLinkData.style || "1rem" }}
              />
              <a
                href={getResourceLinkData.url}
                target="_blank"
                rel="noreferrer"
              >
                {getResourceLinkData.subfeature || "Resource Link"}
              </a>
            </li>
          ) : null}
          <li className="mb-3 fw-bold text-break-all pe-3">
            <FontAwesomeIcon
              icon={faCreditCard}
              className="me-3"
              style={{ fontSize: "1rem" }}
            />
            <a
              onClick={() => setEquipmentTracker(true)}
              style={{
                color: "var(--bs-link-color)",
                cursor: "pointer",
              }}
            >
              Equipment Tracker
            </a>
          </li>
          {isSSOLogin === true && countryName === "MX" && (
            <li className="mb-3 fw-bold text-break-all pe-3">
              <FontAwesomeIcon
                icon={faCreditCard}
                className="me-3"
                style={{ fontSize: "1rem" }}
              />
              <a
                onClick={() => setPluxeeCard(true)}
                style={{
                  color: "var(--bs-link-color)",
                  cursor: "pointer",
                }}
              >
                My Pluxee Card
              </a>
            </li>
          )}
          {isSSOLogin === true &&
            (countryName === "US" ||
              countryName === "MX" ||
              countryName === "PL" ||
              countryName === "PH") && (
              <li className="mb-3 fw-bold text-break-all pe-3">
                <FontAwesomeIcon
                  icon={faMoneyBill}
                  className="me-3"
                  style={{ fontSize: "1rem" }}
                />
                <a
                  onClick={() => setVisible(true)}
                  style={{
                    color: "var(--bs-link-color)",
                    cursor: "pointer",
                  }}
                >
                  View Payment Details
                </a>
              </li>
            )}
          {countryName === "PH" && (
            <li className="mb-3 fw-bold text-break-all pe-3">
              <FontAwesomeIcon
                icon={faTshirt}
                className="me-3"
                style={{ fontSize: "1rem" }}
              />
              <a
                onClick={() => setDresscode(true)}
                style={{
                  color: "var(--bs-link-color)",
                  cursor: "pointer",
                }}
              >
                Dress Code
              </a>
            </li>
          )}
        </ul>

        <Dialog
          header="Your Pay Matters"
          visible={visible}
          style={{ width: "60vw" }}
          onHide={() => setVisible(false)}
          footer={footerContent}
        >
          <DialogBox></DialogBox>
        </Dialog>
        <Dialog
          header="Dress Code"
          visible={DressCode}
          style={{ width: "80vw", height: "100%" }}
          onHide={() => setDresscode(false)}
          footer={footerContentDC}
        >
          <iframe
            title="Dress Code"
            width="100%"
            height="100%"
            src="docs/PH Dresscode.pdf"
          ></iframe>
        </Dialog>
        <Dialog
          header="My Pluxee Card"
          visible={pluxeeCard}
          style={{ width: "60vw" }}
          onHide={() => setPluxeeCard(false)}
          footer={footerContentPC}
        >
          <ScrollPanel style={{ width: "auto", overflow: "auto" }}>
            <p className="text-center">
              <img
                src="./images/My Pluxee Card.png"
                className="img-fluid w-50"
                alt="Pluxee Card"
              ></img>
            </p>
            <p>
              You will receive Pluxee restaurant card as soon as you meet the 90
              days hire date. Download the Pluxee México app below to view the
              list of establishments, where you can use the card to purchase
              meals. <strong>Note</strong>: This benefit is prorated based on
              your hire date.
            </p>
            <p>
              {" "}
              <a
                href="  https://play.google.com/store/apps/details?id=agency.equilibrio.sodexomexico&hl=en_US&gl=US"
                target={"_blank"}
                rel="noreferrer"
              >
                Android Pluxee México App{" "}
              </a>{" "}
            </p>

            <p>
              <a
                href="https://apps.apple.com/si/app/pluxee/id1437173271"
                target={"_blank"}
                rel="noreferrer"
              >
                Apple Pluxee México App{" "}
              </a>{" "}
            </p>
          </ScrollPanel>
        </Dialog>

        <Dialog
          header="FedEx tracker details "
          visible={EquipmentTracker}
          style={{ width: "60vw" }}
          onHide={() => setEquipmentTracker(false)}
          footer={footerContentET}
        >
          {FedExDetailsData !== undefined && (
            <DataTable
              value={listFedExDetails}
              responsiveLayout="scroll"
              className="vertical"
            >
              <Column field="CorpShipDate" header="Date"></Column>
              <Column
                field="TrackingNumber"
                header="Tracking Number"
                body={getLink}
              ></Column>
              <Column
                field="FedExTrackingStatus"
                header="Tracking Status"
              ></Column>
              <Column
                field="FedExTrackingStatusModifiedDate"
                header="Delivered on"
              ></Column>
            </DataTable>
          )}
          {FedExDetailsData === undefined && <p>No record found</p>}
        </Dialog>
        <div className="row mt-5 pt-5">
          <div className="col-md-4">
            <img
              src="./images/louie_book_animation-opimized.gif"
              className="img-fluid"
              alt="Louie Book"
            />
          </div>
          <div className="col-md-8">
            <h2 className="mt-4 text-start">What makes TTEC tick?</h2>
            <p>
              Take a tour with our buddy Louie to learn more about the driving
              purpose, guiding values, and amazing people at the heart of TTEC.
            </p>
            <div className="d-grid gap-2 col-12 col-md-6">
              <a
                className="btn btn-primary p-3"
                type="button"
                href="https://online.flippingbook.com/view/108941/"
                target={"_blank"}
                rel="noreferrer"
              >
                Read all about it
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resources;
